export const fmtCurrency = (n) => {
  const num = Number(n || 0);
  return (num < 0 ? "-₹" : "₹") + Math.abs(num).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const fmtCurrencyFull = (n) => {
  const num = Number(n || 0);
  return (num < 0 ? "-₹" : "₹") + Math.abs(num).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtNumber = (n) => Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const fmtCompact = (n) => {
  const num = Number(n || 0);
  if (Math.abs(num) >= 10000000) return "₹" + (num / 10000000).toFixed(2) + "Cr";
  if (Math.abs(num) >= 100000) return "₹" + (num / 100000).toFixed(2) + "L";
  if (Math.abs(num) >= 1000) return "₹" + (num / 1000).toFixed(1) + "K";
  return "₹" + num.toFixed(0);
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const toCSV = (rows, headers) => {
  const head = headers.map((h) => `"${h.label}"`).join(",");
  const body = rows
    .map((r) => headers.map((h) => `"${String(r[h.key] ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  return head + "\n" + body;
};

export const downloadCSV = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
